import React, { useState } from 'react';
import { useFavorites } from '../contexts/FavoriteContext';
import '../styles/StarButton.css';

const StarButton = ({ stockCode, size = 'medium' }) => {
  const { favoriteStocks, toggleFavorite } = useFavorites();
  const [isToggling, setIsToggling] = useState(false);

  const isFavorite = favoriteStocks.has(stockCode);

  const handleClick = async (e) => {
    e.stopPropagation(); // 테이블 행 클릭 방지

    if (isToggling) return;

    setIsToggling(true);
    try {
      await toggleFavorite(stockCode);
    } catch (error) {
      alert('즐겨찾기 변경에 실패했습니다.');
    } finally {
      setIsToggling(false);
    }
  };

  return (
    <button
      className={`star-button star-button-${size} ${isToggling ? 'toggling' : ''}`}
      onClick={handleClick}
      disabled={isToggling}
      title={isFavorite ? '즐겨찾기 해제' : '즐겨찾기 추가'}
    >
      {isFavorite ? '★' : '☆'}
    </button>
  );
};

export default StarButton;
